<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <!-- Filter tháng -->
      <v-flex lg12>
        <v-card>
          <v-card-text>
            <v-layout row wrap>
              <v-flex lg3 md4 sm6>
                <v-select
                  label="Tháng"
                  v-model="selectedMonth"
                  :items="months"
                  item-text="text"
                  item-value="value"
                  outlined
                  dense
                  @change="loadData"
                ></v-select>
              </v-flex>
              <v-flex lg3 md4 sm6>
                <v-select
                  label="Năm"
                  v-model="selectedYear"
                  :items="years"
                  outlined
                  dense
                  @change="loadData"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- Biểu đồ -->
      <v-flex lg8 md12 v-if="reportData.length > 0">
        <v-card>
          <v-card-title>
            <h3>Tổng sản lượng theo Sale (KG)</h3>
          </v-card-title>
          <v-card-text>
            <div ref="barChart" style="min-height: 400px;"></div>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex lg4 md12 v-if="reportData.length > 0">
        <v-card>
          <v-card-title>
            <h3>Tình trạng thu tiền</h3>
          </v-card-title>
          <v-card-text>
            <div ref="pieChart" style="min-height: 400px;"></div>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- Biểu đồ Doanh thu - Chi phí - Lợi nhuận -->
      <v-flex lg12 v-if="reportData.length > 0">
        <v-card>
          <v-card-title>
            <h3>Doanh thu - Chi phí - Lợi nhuận</h3>
          </v-card-title>
          <v-card-text>
            <div ref="revenueChart" style="min-height: 400px;"></div>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- Bảng thống kê theo Sale -->
      <v-flex lg12>
        <v-card>
          <v-card-title>
            <h3>Báo cáo tháng {{ selectedMonth }}/{{ selectedYear }}</h3>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="reportData"
            :loading="loading"
            disable-pagination
            hide-default-footer
            class="elevation-1"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td>{{ index + 1 }}</td>
                <td>{{ item.SaleName }}</td>
                <td class="text-right">
                  <p>{{ item.TotalWeight | currency('', 1) }}</p>
                  <p>{{ item.TotalVolume | currency('', 2) }}</p>
                </td>
                <td class="text-right">
                  <p>{{ item.ExportedWeight | currency('', 1) }}</p>
                  <p>{{ item.ExportedVolume | currency('', 2) }}</p>
                </td>
                <td class="text-right">
                  <p>{{ item.InventoryCNWeight | currency('', 1) }}</p>
                  <p>{{ item.InventoryCNVolume | currency('', 2) }}</p>
                </td>
                <td class="text-right">
                  <p>{{ item.ExportedVNWeight | currency('', 1) }}</p>
                  <p>{{ item.ExportedVNVolume | currency('', 2) }}</p>
                </td>
                <td class="text-right">
                  <p>{{ item.InventoryWeight | currency('', 1) }}</p>
                  <p>{{ item.InventoryVolume | currency('', 2) }}</p>
                </td>
                <td class="text-right">
                  <p>{{ item.InventoryWeightDebt | currency }}</p>
                  <p>{{ item.InventoryVolumeDebt | currency }}</p>
                </td>
                <td class="text-right">
                  <p>{{ item.PaidAmount | currency }}</p>
                  <p class="red--text">{{ item.PaidAmountOverDue | currency }}</p>
                </td>
                <td class="text-right">
                  <p>{{ item.TotalCost | currency }}</p>
                  <p class="red--text">{{ item.TotalCostOverDue | currency }}</p>
                </td>
                <td class="text-right">
                  <p>{{ item.TotalProfit | currency }}</p>
                  <p class="red--text">{{ item.TotalProfitOverDue | currency }}</p>
                </td>
                <!-- Chi tiết báo cáo theo nhân viên -->
                <td>
                  <v-btn small color="primary" text @click="showDetail(item)">
                    <v-icon small left>mdi-file-document-outline</v-icon>
                    Chi tiết
                  </v-btn>
                </td> 
              </tr>
            </template>
            <template v-slot:body.append>
              <tr class="grey lighten-3 font-weight-bold">
                <td colspan="2">TỔNG CỘNG</td>
                <td class="text-right">
                  <p>{{ totalWeight | currency('', 1) }}</p>
                  <p>{{ totalVolume | currency('', 2) }}</p>
                </td>
                <td class="text-right">
                  <p>{{ totalExportedWeight | currency('', 1) }}</p>
                  <p>{{ totalExportedVolume | currency('', 2) }}</p>
                </td>
                <td class="text-right">
                  <p>{{ totalInventoryCNWeight | currency('', 1) }}</p>
                  <p>{{ totalInventoryCNVolume | currency('', 2) }}</p>
                </td>
                <td class="text-right">
                  <p>{{ totalExportedVNWeight | currency('', 1) }}</p>
                  <p>{{ totalExportedVNVolume | currency('', 2) }}</p>
                </td>
                <td class="text-right">
                  <p>{{ totalInventoryWeight | currency('', 1) }}</p>
                  <p>{{ totalInventoryVolume | currency('', 2) }}</p>
                </td>
                <td class="text-right">
                  <p>{{ totalInventoryWeightDebt | currency }}</p>
                  <p>{{ totalInventoryVolumeDebt | currency }}</p>
                </td>
                <td class="text-right">
                  <p>{{ totalPaidAmount | currency }}</p>
                  <p class="red--text">{{ totalPaidAmountOverDue | currency }}</p>
                </td>
                <td class="text-right">
                  <p>{{ totalCost | currency }}</p>
                  <p class="red--text">{{ totalCostOverDue | currency }}</p>
                </td>
                <td class="text-right">
                  <p>{{ totalProfit | currency }}</p>
                  <p class="red--text">{{ totalProfitOverDue | currency }}</p>
                </td>
                <td></td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Dialog chi tiết -->
    <SalesDetailDialog ref="detailDialog" />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import moment from "moment";
import _ from "lodash";
import Highcharts from "highcharts";
import SalesDetailDialog from "./SalesDetailDialog.vue";

export default {
  components: {
    SalesDetailDialog,
  },
  data() {
    return {
      selectedMonth: moment().month() + 1,
      selectedYear: moment().year(),
      months: [
        { value: 1, text: 'Tháng 1' },
        { value: 2, text: 'Tháng 2' },
        { value: 3, text: 'Tháng 3' },
        { value: 4, text: 'Tháng 4' },
        { value: 5, text: 'Tháng 5' },
        { value: 6, text: 'Tháng 6' },
        { value: 7, text: 'Tháng 7' },
        { value: 8, text: 'Tháng 8' },
        { value: 9, text: 'Tháng 9' },
        { value: 10, text: 'Tháng 10' },
        { value: 11, text: 'Tháng 11' },
        { value: 12, text: 'Tháng 12' },
      ],
      years: [],
      headers: [
        { text: 'STT', value: 'index', width: '60px', sortable: false },
        { text: 'Tên Sale', value: 'SaleName', sortable: false },
        { text: 'Tổng sản lượng', value: 'TotalWeight', align: 'end', sortable: true },
        { text: 'Xuất kho TQ', value: 'ExportedWeight', align: 'end', sortable: false },
        { text: 'Tồn kho TQ', value: 'InventoryCNWeight', align: 'end', sortable: false },
        { text: 'Xuất kho VN', value: 'ExportedVNWeight', align: 'end', sortable: false },
        { text: 'Tồn kho VN', value: 'InventoryWeight', align: 'end', sortable: false },
        { text: 'Nợ tồn kho', value: 'InventoryWeightDebt', align: 'end', sortable: false },
        { text: 'Doanh thu', value: 'PaidAmount', align: 'end', sortable: false },
        { text: 'Chi phí', value: 'TotalCost', align: 'end', sortable: false },
        { text: 'Lợi nhuận', value: 'TotalProfit', align: 'end', sortable: false },
        { text: 'Chi tiết', value: 'details', sortable: false },
      ],
      reportData: [],
      loading: false,
    };
  },
  computed: {
    totalWeight() {
      return _.sumBy(this.reportData, 'TotalWeight') || 0;
    },
    totalVolume() {
      return _.sumBy(this.reportData, 'TotalVolume') || 0;
    },
    totalExportedWeight() {
      return _.sumBy(this.reportData, 'ExportedWeight') || 0;
    },
    totalExportedVolume() {
      return _.sumBy(this.reportData, 'ExportedVolume') || 0;
    },
    totalInventoryCNWeight() {
      return _.sumBy(this.reportData, 'InventoryCNWeight') || 0;
    },
    totalInventoryCNVolume() {
      return _.sumBy(this.reportData, 'InventoryCNVolume') || 0;
    },
    totalExportedVNWeight() {
      return _.sumBy(this.reportData, 'ExportedVNWeight') || 0;
    },
    totalExportedVNVolume() {
      return _.sumBy(this.reportData, 'ExportedVNVolume') || 0;
    },
    totalInventoryWeight() {
      return _.sumBy(this.reportData, 'InventoryWeight') || 0;
    },
    totalInventoryVolume() {
      return _.sumBy(this.reportData, 'InventoryVolume') || 0;
    },
    totalInventoryWeightDebt() {
      return _.sumBy(this.reportData, 'InventoryWeightDebt') || 0;
    },
    totalInventoryVolumeDebt() {
      return _.sumBy(this.reportData, 'InventoryVolumeDebt') || 0;
    },
    totalPaidAmount() {
      return _.sumBy(this.reportData, 'PaidAmount') || 0;
    },
    totalPaidAmountOverDue() {
      return _.sumBy(this.reportData, 'PaidAmountOverDue') || 0;
    },
    totalUnPaidAmount() {
      return _.sumBy(this.reportData, 'UnPaidAmount') || 0;
    },
    totalCost() {
      return _.sumBy(this.reportData, 'TotalCost') || 0;
    },
    totalCostOverDue() {
      return _.sumBy(this.reportData, 'TotalCostOverDue') || 0;
    },
    totalProfit() {
      return _.sumBy(this.reportData, 'TotalProfit') || 0;
    },
    totalProfitOverDue() {
      return _.sumBy(this.reportData, 'TotalProfitOverDue') || 0;
    },
  },
  watch: {
    reportData() {
      this.$nextTick(() => {
        this.renderCharts();
      });
    }
  },
  methods: {
    initYears() {
      const currentYear = moment().year();
      for (let i = currentYear; i >= currentYear - 5; i--) {
        this.years.push(i);
      }
    },
    loadData() {
      this.loading = true;
      const param = {
        month: this.selectedMonth,
        year: this.selectedYear,
      };
      
      this.$store.dispatch("report/getSalesDashboard", param).then((data) => {
        this.reportData = _.orderBy(data, ['TotalWeight'], ['desc']);
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    renderCharts() {
      if (!this.reportData || this.reportData.length === 0) {
        return;
      }
      
      this.renderBarChart();
      this.renderPieChart();
      this.renderRevenueChart();
    },
    renderBarChart() {
      const container = this.$refs.barChart;
      if (!container) return;
      
      const categories = this.reportData.map(item => item.SaleName);
      const totalWeights = this.reportData.map(item => parseFloat(item.TotalWeight || 0));
      const exportedWeights = this.reportData.map(item => parseFloat(item.ExportedWeight || 0));
      const inventoryWeights = this.reportData.map(item => parseFloat(item.InventoryWeight || 0));
      
      Highcharts.chart(container, {
        chart: {
          type: 'column'
        },
        title: {
          text: null
        },
        xAxis: {
          categories: categories,
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Khối lượng (KG)'
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f} KG</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [{
          name: 'Tổng sản lượng',
          data: totalWeights,
          color: '#42A5F5'
        }, {
          name: 'Đã xuất kho',
          data: exportedWeights,
          color: '#66BB6A'
        }, {
          name: 'Tồn kho',
          data: inventoryWeights,
          color: '#FFA726'
        }],
        credits: {
          enabled: false
        }
      });
    },
    renderPieChart() {
      const container = this.$refs.pieChart;
      if (!container) return;
      
      const paidAmount = this.totalPaidAmount;
      const unpaidAmount = this.totalUnPaidAmount;
      
      Highcharts.chart(container, {
        chart: {
          type: 'pie'
        },
        title: {
          text: null
        },
        tooltip: {
          pointFormat: '<b>{point.percentage:.1f}%</b><br/>{point.y:,.0f} VND'
        },
        accessibility: {
          point: {
            valueSuffix: ' VND'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %'
            },
            showInLegend: true
          }
        },
        series: [{
          name: 'Số tiền',
          colorByPoint: true,
          data: [{
            name: 'Đã thu tiền',
            y: paidAmount,
            color: '#66BB6A'
          }, {
            name: 'Chưa thu tiền',
            y: unpaidAmount,
            color: '#EF5350'
          }]
        }],
        credits: {
          enabled: false
        }
      });
    },
    renderRevenueChart() {
      const container = this.$refs.revenueChart;
      if (!container) return;
      
      const categories = this.reportData.map(item => item.SaleName);
      const revenue = this.reportData.map(item => parseFloat((item.PaidAmount || 0) + (item.UnpaidAmount || 0)));
      const cost = this.reportData.map(item => parseFloat(item.TotalCost || 0));
      const profit = this.reportData.map(item => parseFloat(item.TotalProfit || 0));
      
      Highcharts.chart(container, {
        chart: {
          type: 'column'
        },
        title: {
          text: null
        },
        xAxis: {
          categories: categories,
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Số tiền (VND)'
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:,.0f} VND</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [{
          name: 'Tổng doanh thu',
          data: revenue,
          color: '#42A5F5'
        }, {
          name: 'Tổng chi phí',
          data: cost,
          color: '#EF5350'
        }, {
          name: 'Tổng lợi nhuận',
          data: profit,
          color: '#66BB6A'
        }],
        credits: {
          enabled: false
        }
      });
    },
    showDetail(item) {
      this.$refs.detailDialog.open(
        item.SaleID,
        item.SaleName,
        this.selectedMonth,
        this.selectedYear
      );
    },
  },
  mounted() {
    this.initYears();
    this.loadData();
    this.$root.$on("REQUEST_REFRESH_DATA", this.loadData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.loadData);
  },
};
</script>

<style scoped>
.font-weight-bold td {
  font-weight: bold !important;
}
</style>
